/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BbsCategoryInfoRespVo } from './BbsCategoryInfoRespVo';
import {
    BbsCategoryInfoRespVoFromJSON,
    BbsCategoryInfoRespVoFromJSONTyped,
    BbsCategoryInfoRespVoToJSON,
    BbsCategoryInfoRespVoToJSONTyped,
} from './BbsCategoryInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseBbsCategoryInfoRespVo
 */
export interface ResponseBbsCategoryInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBbsCategoryInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBbsCategoryInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {BbsCategoryInfoRespVo}
     * @memberof ResponseBbsCategoryInfoRespVo
     */
    data?: BbsCategoryInfoRespVo;
}

/**
 * Check if a given object implements the ResponseBbsCategoryInfoRespVo interface.
 */
export function instanceOfResponseBbsCategoryInfoRespVo(value: object): value is ResponseBbsCategoryInfoRespVo {
    return true;
}

export function ResponseBbsCategoryInfoRespVoFromJSON(json: any): ResponseBbsCategoryInfoRespVo {
    return ResponseBbsCategoryInfoRespVoFromJSONTyped(json, false);
}

export function ResponseBbsCategoryInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBbsCategoryInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BbsCategoryInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseBbsCategoryInfoRespVoToJSON(json: any): ResponseBbsCategoryInfoRespVo {
    return ResponseBbsCategoryInfoRespVoToJSONTyped(json, false);
}

export function ResponseBbsCategoryInfoRespVoToJSONTyped(value?: ResponseBbsCategoryInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BbsCategoryInfoRespVoToJSON(value['data']),
    };
}

